// http 200 成功code值
export const ERR_OK = '0000'

// 登录过期
export const LOGIN_EXPIRED = '9999'

// 审批时需跨级审批
export const NEED_CROSS_APPROVAL = '3000'
// 预警提示
export const WARN_CROSS_APPROVAL = '6666'
// 查看是否重复
export const APPLY_REPEAD = '4000'
